import { createElement } from 'react';
import classNames from "classnames";
const classPrefix = `au-dropdown-item`;
const MenuItem = props => {
    const { title, active, arrow, onClick } = props;
    const cls = classNames(classPrefix, {
        [`${classPrefix}-active`]: props.active,
    });
    const handleClick = (e) => {
        if (onClick) {
            onClick(e);
        }
    };
    return (createElement("div", { className: cls, onClick: handleClick },
        createElement("div", { className: `${classPrefix}-title` },
            createElement("span", { className: `${classPrefix}-title-text` }, title),
            createElement("span", { className: classNames(`${classPrefix}-title-arrow`, {
                    [`${classPrefix}-title-arrow-active`]: active,
                }) }, arrow === undefined ? createElement("i", { className: "triangle" }) : arrow)),
        createElement("div", { className: `${classPrefix}-hr` })));
};
export default MenuItem;
export const WrapItem = props => {
    const { active = false, children } = props;
    const cls = classNames(`${classPrefix}-content`, {
        [`${classPrefix}-content-hidden`]: !active,
    });
    return (createElement("div", { className: cls }, children));
};
